// Mg BodyCare: AJAX add-to-cart for all Mg buttons -> opens Ritual's cart drawer.
// Falls back to the normal cart page if anything is unavailable.
const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
let Ev = null;
import('@shopify/events').then((m) => { Ev = m; }).catch(() => {});

function setBusy(form, on) {
  const b = form.querySelector('[type=submit]');
  if (on) form.dataset.mgBusy = '1'; else delete form.dataset.mgBusy;
  if (b) { b.toggleAttribute('aria-busy', on); b.style.opacity = on ? '.7' : ''; b.style.pointerEvents = on ? 'none' : ''; }
}
function showError(form, msg) {
  let p = form.querySelector('.mg-error[data-mg-ajax]');
  if (!p) { p = document.createElement('p'); p.className = 'mg-error'; p.setAttribute('role', 'alert'); p.dataset.mgAjax = ''; form.appendChild(p); }
  p.textContent = msg || 'Sorry, this item could not be added. Please try again.';
  setTimeout(() => p.remove(), 8000);
}
const getCart = () => fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) => r.json());

document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (!(form instanceof HTMLFormElement) || !form.closest('.mg')) return;
  if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
  if (!document.querySelector('cart-drawer-component') || !window.fetch) return; // native submit -> cart page
  e.preventDefault();
  if (form.dataset.mgBusy) return;
  setBusy(form, true);

  const fd = new FormData(form);
  const qty = Math.max(1, parseInt(fd.get('quantity') || '1', 10) || 1);
  fd.set('quantity', String(qty));
  const ids = [...document.querySelectorAll('cart-items-component[data-section-id]')].map((x) => x.dataset.sectionId).filter(Boolean);
  if (ids.length) fd.set('sections', [...new Set(ids)].join(','));

  let deferred = null;
  try {
    if (Ev && Ev.CartLinesUpdateEvent) {
      deferred = Ev.CartLinesUpdateEvent.createPromise();
      form.dispatchEvent(new Ev.CartLinesUpdateEvent({
        action: 'add', context: 'product',
        lines: [{ merchandiseId: String(fd.get('id')), quantity: qty }],
        promise: deferred.promise,
      }));
    }
  } catch (_) { deferred = null; }

  try {
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: fd,
    }).then((r) => r.json());

    const cart = await getCart();
    if (res.status) {
      showError(form, res.description || res.message);
      if (deferred) deferred.resolve({ cart: Ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: true, items: cart.items, source: 'product-form-component', itemCount: qty } });
      return;
    }
    if (!deferred) { window.location.href = root + 'cart'; return; }
    deferred.resolve({
      cart: Ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'product-form-component', sourceId: form.id || 'mg-form', itemCount: qty, sections: res.sections, didError: false },
    });
    const q = form.querySelector('input[name="quantity"][type="number"]');
    if (q) q.value = '1';
    setTimeout(() => {
      const drawer = document.querySelector('#cart-drawer');
      if (drawer && !drawer.hasAttribute('open') && typeof drawer.open === 'function') drawer.open();
      setTimeout(() => { if (drawer && !drawer.hasAttribute('open') && !document.querySelector('#cart-drawer dialog[open]')) window.location.href = root + 'cart'; }, 700);
    }, 250);
  } catch (err) {
    if (deferred) try { deferred.reject(err); } catch (_) {}
    HTMLFormElement.prototype.submit.call(form);
  } finally {
    setBusy(form, false);
  }
});
